import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface Props {
  backgroundImage?: {
    _?: string;
    md?: string;
  };
  title?: string;
  subtitle?: string;
  techSystems?: {
    title?: string;
    items?: {
      title?: string;
      subtitle?: string;
    }[];
  },
  techPlatforms?: {
    title?: string;
    items?: {
      title?: string;
      tags?: {
        label?: string;
      }[];
    }[];
  };
  cocreationText?: string;
  platformCard?: {
    text1?: string;
    text2?: string;
    text3?: string;
  };
}

const propsSchema: PropsSchemaList = [
  {
    key: 'backgroundImage',
    label: 'Background Image',
    type: types.OBJECT,
    children: [
      {
        key: '_',
        label: 'Mobile (or Base)',
        type: types.S3_ASSET_URL,
      },
      {
        key: 'md',
        label: 'Desktop',
        type: types.S3_ASSET_URL,
      },
    ],
  },
  {
    key: 'title',
    label: 'Title',
    type: types.TEXT,
  },
  {
    key: 'subtitle',
    label: 'Subtitle',
    type: types.TEXT,
  },
  {
    key: 'techSystems',
    label: 'Tech Systems',
    type: types.OBJECT,
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'items',
        label: 'Items',
        type: types.ARRAY,
        children: [
          {
            key: 'title',
            label: 'Title',
            type: types.TEXT,
          },
          {
            key: 'subtitle',
            label: 'Subtitle',
            type: types.TEXT,
          },
        ],
      },
    ],
  },
  {
    key: 'techPlatforms',
    label: 'Tech Platforms',
    type: types.OBJECT,
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'items',
        label: 'Items',
        type: types.ARRAY,
        children: [
          {
            key: 'title',
            label: 'Title',
            type: types.TEXT,
          },
          {
            key: 'tags',
            label: 'Tags',
            type: types.ARRAY,
            children: [
              {
                key: 'label',
                label: 'Label',
                type: types.TEXT,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    key: 'cocreationText',
    label: 'Cocreation Text',
    type: types.TEXT,
  },
  {
    key: 'platformCard',
    label: 'Title',
    type: types.OBJECT,
    children: [
      {
        key: 'text1',
        label: 'Text 1',
        type: types.TEXT,
      },
      {
        key: 'text2',
        label: 'Text 2',
        type: types.TEXT,
      },
      {
        key: 'text3',
        label: 'Text 3',
        type: types.TEXT,
      },
    ]
  },
];

const defaultProps: Props = {
  title: 'FF aiHyper 6x4 Architecture 2.0',
  subtitle: 'All-AI All-Hyper All-Ability Co-creation',
  techSystems: {
    title: '4 Tech Systems',
    items: [
      {
        title: 'Magic All-In-One',
        subtitle: 'All-Terrain AI Body Control Technolog',
      },
      {
        title: 'Hyper Multi-Vectoring',
        subtitle: 'Integrated multi-axis torque technology system for AI propulsion, steering and braking',
      },
      {
        title: '3rd aiSpace',
        subtitle: 'AI Space & Internet Technology System',
      },
      {
        title: 'FF aiDriving',
        subtitle: 'aiDriving Technology System',
      },
    ],
  },
  techPlatforms: {
    title: '6 Tech Platforms',
    items: [
      {
        title: 'FF OpenApp',
        tags: [
          {
            label: 'Development Kit',
          },
          {
            label: 'AIUI for Application',
          },
          {
            label: 'Data & Security Management',
          },
          {
            label: 'Developer Portal',
          },
          {
            label: 'Application Market',
          },
        ],
      },
      {
        title: 'FF aiOS 2',
        tags: [
          {
            label: 'User Interface',
          },
          {
            label: 'FF Framework',
          },
          {
            label: 'Multi-User Management',
          },
          {
            label: 'Cyber Security',
          },
          {
            label: 'Resources Management',
          },
          {
            label: 'Hardware Abstraction Layer',
          },
          {
            label: 'Kernel',
          },
        ],
      },
      {
        title: 'FF aiHW 2.0',
        tags: [
          {
            label: 'Computing',
          },
          {
            label: 'V-Network',
          },
          {
            label: 'Communication',
          },
          {
            label: 'Sensing',
          },
          {
            label: 'Displays & Sound',
          },
          {
            label: 'Lighting',
          },
        ],
      },
      {
        title: 'FF Mechanical',
        tags: [
          {
            label: 'Material',
          },
          {
            label: 'Structural',
          },
          {
            label: 'Movable',
          },
          {
            label: 'High-Voltage',
          },
          {
            label: 'Electric Driving',
          },
          {
            label: 'Energy Exchanging',
          },
        ],
      },
      {
        title: 'FF Cloud',
        tags: [
          {
            label: 'Safety',
          },
          {
            label: 'Computing',
          },
          {
            label: 'Storage',
          },
          {
            label: 'Network',
          },
          {
            label: 'Big Data',
          },
          {
            label: 'Web3',
          },
          {
            label: 'AI Training',
          },
        ],
      },
      {
        title: 'FF AI',
        tags: [
          {
            label: 'CNN',
          },
          {
            label: 'RNN',
          },
          {
            label: 'GNN',
          },
          {
            label: 'Transformer',
          },
          {
            label: 'GPT',
          },
          {
            label: 'Reinforcement Learning',
          },
        ],
      },
    ],
  },
  cocreationText: 'Developers Open Co-creation',
  platformCard: {
    text1: 'CV NLP....',
    text2: 'Platform ALL AI',
    text3: 'AI Engine',
  }
};

export default {
  title: 'ai Hyper Architecture',
  id: 'AiHyperArchitecture',
  propsSchema,
  defaultProps,
}
